import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, Eye, Heart, MessageCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const BlogCard = ({ article, delay = 0 }) => {
  const { language } = useLanguage();
  
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString(language === "fr" ? "fr-FR" : "en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      data-testid={`blog-card-${article.slug}`}
      className="group"
    >
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative overflow-hidden rounded-2xl mb-4 aspect-video">
          <img
            src={article.cover_image}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>

        <div className="space-y-3">
          {article.tags && article.tags.length > 0 && (
            <div className="flex flex-wrap gap-2">
              {article.tags.slice(0, 3).map((tag) => (
                <span
                  key={tag}
                  className="text-xs font-medium px-2 py-1 rounded-full bg-primary/10 text-primary"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}

          <h3 className="font-heading font-bold text-base sm:text-xl text-foreground group-hover:text-primary transition-colors line-clamp-2">
            {article.title}
          </h3>

          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs sm:text-sm text-muted-foreground">
            <span className="flex items-center gap-1">
              <Calendar className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              {formatDate(article.created_at)}
            </span>
            <span className="flex items-center gap-1">
              <Eye className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              {article.views}
            </span>
            <span className="flex items-center gap-1">
              <Heart className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              {article.likes_count}
            </span>
            <span className="flex items-center gap-1">
              <MessageCircle className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              {article.comments_count}
            </span>
          </div>

          <p className="text-muted-foreground text-sm line-clamp-2">
            {article.content.substring(0, 150).replace(/[#*`]/g, "")}...
          </p>
        </div>
      </Link>
    </motion.article>
  );
};

export default BlogCard;
